// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 应用关系类型枚举 枚举类
 * 应用关系类型枚举
 */
export enum EnumAPPRelationshipType {
  /** 菜单包含 : 菜单包含 */
  MenuContain = 1,
  /** 任务顺序 : 任务顺序 */
  TaskSequence = 2
}

/**
 * 应用关系类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumAPPRelationshipTypeMD {
  private static items = [
    new EnumItemMD('MenuContain', 1, '菜单包含', '菜单包含'),
    new EnumItemMD('TaskSequence', 2, '任务顺序', '任务顺序')
  ];

  static getItem(enumItem: EnumAPPRelationshipType) {
    return this.items.find(item => item.name === EnumAPPRelationshipType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
